import Action from "../base/action";

class TrackTime extends Action {
    variableName;
    _trackTimeStart;

    constructor(props) {
        super(props);
        this.variableName = props.variableName || "";
    }

    async execute(eventLoop) {
        this._trackTimeStart = new Date();
    }

    async stop(training) {
        if (!this.variableName) {
            console.error("Variable is not set.");
            return;
        }

        const durationMs = new Date() - this._trackTimeStart;
        training.registry.set(this.variableName, durationMs/1000);
    }
}

export default TrackTime;
